import React from 'react';
import { Text, Box } from '@chakra-ui/react';
import { TbCopy } from 'react-icons/tb';
import CopyButton from '../CopyButton';

interface SupplierPartNumberProps {
    partNumber: string;
    correctedPartNumber?: string;
    supplierPartNumber?: string | null;
    inactive?: boolean;
    textColor?: string;
}

const SupplierPartNumber = ({
    partNumber,
    correctedPartNumber,
    supplierPartNumber,
    inactive,
    textColor = 'gray.900',
}: SupplierPartNumberProps) => {
    const value = supplierPartNumber?.trim();
    const oePartNumber = (correctedPartNumber ?? partNumber)?.trim();

    if (!value || (oePartNumber && value.toLowerCase() === oePartNumber.toLowerCase())) {
        return (
            <Text color="gray.900" fontSize="sm" textDecoration={inactive ? 'line-through' : undefined}>
                —
            </Text>
        );
    }

    return (
        <CopyButton
            text={value}
            label="Copy supplier part number"
            iconAs={TbCopy as unknown as React.ComponentProps<typeof CopyButton>['iconAs']}
            tooltipAnchor={
                <Box textDecoration={inactive ? 'line-through' : undefined}>
                    <Text color={textColor} fontSize="sm">
                        {value}
                    </Text>
                </Box>
            }
        />
    );
};

export default SupplierPartNumber;
